import { createLogger } from 'redux-logger';
export var loggerMiddleware = createLogger();
